import useDealRequest, {
  EDealRequestType,
  IDealRequestCommonSchema,
} from 'api/hooks/use-deal-request';
import { MarketTypes } from 'api/types';
import BottomSheet from 'components/bottom-sheet';
import Header from 'components/header';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IDataModal } from 'screens/estimate';
import FormRequest from 'screens/estimate/components/forms/formRequest/formRequest';
import useBoundStore from 'store';

interface IModalTradeInProps {
  isOpen: boolean;
  data: IDataModal;
  onDismiss: (value: boolean) => void;
}
export interface IDataRansom {
  userApartmentNumber: string;
  apartmentType?: string;
  areaInSqM: string;
  address?: string;
  buildingId: number;
  complexId?: number;
  streetId?: number;
  typeId?: number;
  estimatedPrice?: number;
}

const TEXT = `Компания Reit купит вашу квартиру в минимальный срок. Оставьте заявку, чтобы узнать на какую сумму за продажу вашей квартиры вы можете рассчитывать уже сегодня.
Укажите номер квартиры и оставьте заявку. Наш эксперт свяжется с вами для уточнения нюансов.`;

const ModalRansom = ({ isOpen, data, onDismiss }: IModalTradeInProps) => {
  const initDataRansom = {
    userApartmentNumber: '',
    address: data.address,
    apartmentType: data.typeApartment,
    areaInSqM: data.areaInSqM,
    buildingId: data.buildingId,
    complexId: data.complexId,
    streetId: data.streetId,
    typeId: data.typeApartmentId,
    estimatedPrice: data.estimatedPrice,
  };

  const [dataRansom, setDataRansom] = useState<IDataRansom>(initDataRansom);

  const onChangeData = (value: string, key: string) => {
    setDataRansom((prev) => ({ ...prev, [key]: value }));
  };

  const { error, isMutating, trigger } = useDealRequest();

  useEffect(() => {
    setDataRansom(initDataRansom);
  }, [isOpen]);

  const handleSubmit = async () => {
    if (dataRansom.buildingId && dataRansom.userApartmentNumber && dataRansom.areaInSqM) {
      await trigger({
        type: EDealRequestType.Ransom,
        data: {
          areaInSqM: Number(dataRansom.areaInSqM),
          buildingId: dataRansom.buildingId,
          apartmentNumber: dataRansom.userApartmentNumber,
          complexId: dataRansom.complexId,
          streetId: dataRansom.streetId,
          typeId: dataRansom.typeId,
          estimatedPrice: dataRansom.estimatedPrice,
        } as IDealRequestCommonSchema,
        marketType: MarketTypes.SECONDARY,
        mode: 'outOfSystem',
      });
    }
    toast.success(
      'Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время.',
    );
    onDismiss(false);
  };

  const handleDismiss = () => {
    onDismiss(false);
    setIsShowKeyBoardHeight(false);
  };

  const setIsShowKeyBoardHeight = useBoundStore((s) => s.setIsShowKeyBoardHeight);

  return (
    <BottomSheet
      initialFocusRef={false}
      open={isOpen}
      onDismiss={handleDismiss}
      snapPoints={({ minHeight, maxHeight }) => maxHeight - 100}
      header={<Header text='Выкуп' />}
    >
      <FormRequest
        text={TEXT}
        buttonLabel='Оставить заявку на выкуп'
        titleForPatForm={'Квартира выкупа:'}
        onClick={handleSubmit}
        type='sell'
        labelForApartment='Квартира:'
        data={dataRansom}
        onChange={onChangeData}
        isLoading={isMutating}
        onFocusInput={() => setIsShowKeyBoardHeight(true)}
        onBlurInput={() => setIsShowKeyBoardHeight(false)}
      />
    </BottomSheet>
  );
};
export default ModalRansom;
